import { getTemplateNavHeaderStyles } from './NavHeader.styles'
const t = document.createElement('template')
t.innerHTML = `
<div>
  <slot></slot>
</div>    
`
class NavHeaderUtilityButtonGroup extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilityButtonGroup connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-utility-buttongroup')) {
  customElements.define('ts-navheader-utility-buttongroup', NavHeaderUtilityButtonGroup)
}
export { NavHeaderUtilityButtonGroup }